import { TableBaseCols } from '@ge/feat-reporting/components/widgets/table-widget/table-base-cols';

// All available columns and groups for completed work
export const InternalExceptionDamagesColumns = {
  GROUP_SELECTED: TableBaseCols.GROUP_SELECTED,
  SELECTED: TableBaseCols.SELECTED,

  GROUP_COLUMNS: 'Columns',
  ASSET: 'Asset',
  MODEL: 'Model',
  COMPONENT: 'Component',
  LOCATION: 'Location',
  DAMAGE: 'Damage',
  PAC: 'pacNumber',
  CATEGORY: 'Category',
  P50: 'p50',
  P90: 'p90',
  SERIAL_NUMBER: 'Serial Number',
  MANUFACTURER: 'Manufacturer',
  PART: 'Part',
};

// Completed work table configuration
export const internalExceptionDamagesColumnsDefs = {
  [InternalExceptionDamagesColumns.GROUP_COLUMNS]: {
    align: 'left',
    labels: [
      {
        a11yKey: 'external_damages.columns.group_columns',
        a11yDefault: 'Columns',
      },
    ],
    cols: {
      [InternalExceptionDamagesColumns.ASSET]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.asset_name',
            a11yDefault: 'Asset',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalExceptionDamagesColumns.MODEL]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.model',
            a11yDefault: 'Model',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalExceptionDamagesColumns.COMPONENT]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.component',
            a11yDefault: 'Component',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalExceptionDamagesColumns.LOCATION]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.location',
            a11yDefault: 'Location',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalExceptionDamagesColumns.DAMAGE]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.damage',
            a11yDefault: 'Damage',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalExceptionDamagesColumns.PAC]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.pac',
            a11yDefault: 'PAC #',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalExceptionDamagesColumns.PART]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.part',
            a11yDefault: 'Part',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalExceptionDamagesColumns.CATEGORY]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.category',
            a11yDefault: 'Category',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalExceptionDamagesColumns.MANUFACTURER]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.manufacturer',
            a11yDefault: 'Manufacturer',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalExceptionDamagesColumns.P50]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.rul_50',
            a11yDefault: 'RUL P50',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalExceptionDamagesColumns.P90]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.rul_90',
            a11yDefault: 'RUL P90',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [InternalExceptionDamagesColumns.SERIAL_NUMBER]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.serial_number',
            a11yDefault: 'Serial Number',
          },
        ],
        cell: {
          align: 'left',
        },
      },
    },
  },
};

export const InternalExceptionDamagesColumnsDefaultCols = [
  {
    id: InternalExceptionDamagesColumns.GROUP_COLUMNS,
    ignoreTemplateConfig: true,
    cols: [
      {
        id: InternalExceptionDamagesColumns.ASSET,
        visible: true,
      },
      {
        id: InternalExceptionDamagesColumns.MODEL,
        visible: false,
        ignoreTemplateConfig: true,
      },
      {
        id: InternalExceptionDamagesColumns.COMPONENT,
        visible: true,
      },
      {
        id: InternalExceptionDamagesColumns.LOCATION,
        visible: true,
      },
      {
        id: InternalExceptionDamagesColumns.DAMAGE,
        visible: true,
      },
      {
        id: InternalExceptionDamagesColumns.PAC,
        visible: true,
      },
      {
        id: InternalExceptionDamagesColumns.PART,
        visible: false,
        ignoreTemplateConfig: true,
      },
      {
        id: InternalExceptionDamagesColumns.CATEGORY,
        visible: true,
      },
      {
        id: InternalExceptionDamagesColumns.MANUFACTURER,
        visible: false,
        ignoreTemplateConfig: true,
      },
      {
        id: InternalExceptionDamagesColumns.P50,
        visible: true,
      },
      {
        id: InternalExceptionDamagesColumns.P90,
        visible: true,
      },
      {
        id: InternalExceptionDamagesColumns.SERIAL_NUMBER,
        visible: false,
        ignoreTemplateConfig: true,
      },
    ],
  },
];

export const PerformanceStateKeys = {
  CONFIG_STATE: 'configState',
};
